var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkSolidDocSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-park-solid_doc-search_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 36,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4H10a2 2 0 00-2 2v36a2 2 0 002 2h28a2 2 0 002-2V6a2 2 0 00-2-2z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16a5 5 0 11-10-.003A5 5 0 0128 16z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23l-3.465-3.465m0 0a5 5 0 10-7.071-7.07 5 5 0 007.071 7.07zM17 30h14m-14 6h7",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-park-solid_doc-search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0V0z",
    fill: "#fff"
  }))));
}
export default SvgIconParkSolidDocSearch;